/* eslint-disable no-param-reassign */
import { OYIndustryComponetData } from "../components/OYIndustryComponet/const";
import {IValueData} from "data";

/**
 *  合并对象
 *
 * @export
 * @param {{ [i: string]: any }} target
 * @param {{ [i: string]: any }} source
 * @returns
 */
export function assign(target: { [i: string]: any }, source: { [i: string]: any }) {
  // eslint-disable-next-line guard-for-in
  for (const obj in source) {
    target[obj] = source[obj];
  }
  return target;
}

export function omit<T>(object: T, keys: (keyof T)[]) {
  const newObj: any = {};

  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      if (keys.indexOf(key) === -1) {
        newObj[key] = object[key];
      }
    }
  }

  return newObj;
}

export function picker<T>(object: T, keys: (keyof T)[]) {
  const newObj: any = {};

  for (const key in object) {
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      if (keys.indexOf(key) !== -1) {
        newObj[key] = object[key];
      }
    }
  }

  return newObj;
}

export function getAttributes(element: Element) {
  const attributes: { [i: string]: string } = {};
  $.each(element.attributes, (_index, attribute) => {
    attributes[attribute.name] = attribute.value;
  })

  return attributes;
}

export function isFunc(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Function]';
}

export function isArray(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Array]';
}

export function isObject(obj: any) {
  return Object.prototype.toString.call(obj) === '[object Object]';
}

/**
 * 判断是否是字符串数组
 * @param data
 */
export function isStringArray(data: any) {
  if (!isArray(data)) {
    return false;
  }

  let flag = true;
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let index = 0; index < data.length; index++) {
    const element = data[index];
    if (typeof data[index] !== 'string') {
      flag = false;
      break;
    }
  }
  return flag;
}

export function classnames(data: any[], log = false) {
  // console.log(data.filter(da => da && typeof da === 'string').join(' '))
  const classString = data.filter(da => da && typeof da === 'string').join(' ');
  if (log) {
    console.log(classString);
  }
  return classString
}

export function valueIncludes(data: string[], key = '') {
  const skey = `${key}`;
  let flag = false;
  if (!skey) {
    return flag
  }
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let index = 0; index < data.length; index++) {
    const element = `${data[index]}`;
    if (element === skey) {
      flag = true;
      break;
    }
  }
  return flag;
}

export function industryComponetInclueds(value = '', data: OYIndustryComponetData) {
  if (!value || !data) {
    return false;
  }

  if (data.code === value) {
    return true
  }

  return data.button.filter(va => va).map(va => `${va?.code}`).includes(value)
}

export function containsObject(target: IValueData, containsKey: string, source: IValueData[]) {
  if (!target || !source ||!containsKey) {
    return false
  }

  return source.findIndex(info=> {
    return info[containsKey] === target[containsKey]
  })<0
}

/**
 * 深合并
 * @param target
 * @param ...sources
 */
export function mergeDeep<T>(target: any, ...sources: any[]): T {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) {
          Object.assign(target, { [key]: {} });
        }
        mergeDeep(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return mergeDeep(target, ...sources);
}

/**
 * 返回唯一的的字符串数组
 *
 * 字符串数组去重
 * @param data
 */
export function stringSet(data: string[]) {
  const sets: string[] = [];
  data.forEach(key => {
    if (sets.indexOf(key) === -1) {
      sets.push(key);
    }
  })
  return sets;
}

function trim(va: string) {
  if (!va) return va;
  return va.replace(/^\s+/g, '').replace(/\s+$/g, '')
}

export function dateFormatFromTimeStamp(curTimeStamp: number){
  const curTime = new Date(curTimeStamp);
  return dateFormat(curTime)
}

export function stringFormat(mm: string | any[], interval: string , replaceEnter: boolean) {
  // eslint-disable-next-line no-param-reassign
  mm = $.isArray(mm) ? mm : [mm];
  let str = ''
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let ii = 0; ii < mm.length; ii++) {
    if (mm[ii] && mm[ii].toString().length) {
      str += trim(mm[ii].toString());
    };
  };
  if (replaceEnter) {
    str = str.replace(/;/g,";\n")
    str = str.replace(/；/g,"；\n")
  }
  return str.length ? str : (interval || '-');
}

export function dateFormat(date: Date, fmt = 'yyyy-MM-dd') {
  const obj: any = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
    "H+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    "S": date.getMilliseconds() // 毫秒
  };
  const week: any = {
    "0": "/u65e5",
    "1": "/u4e00",
    "2": "/u4e8c",
    "3": "/u4e09",
    "4": "/u56db",
    "5": "/u4e94",
    "6": "/u516d"
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (String(date.getFullYear())).substr(4 - RegExp.$1.length));
  }
  if (/(E+)/.test(fmt)) {
    // eslint-disable-next-line no-nested-ternary
    fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? "/u661f/u671f" : "/u5468") : "") + week[String(date.getDay())]);
  }
  for (const kk in obj) {
    if (new RegExp("(" + kk + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (obj[kk]) : (("00" + obj[kk]).substr((String(obj[kk])).length)));
    }
  }
  return fmt;
}
/**
* 时间戳转换成日期
* @param timestamp
* @returns {*}
*/
export function timestampToTime(timestamp: any) {
  var date = new Date(timestamp / 1000)//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var seperator1 = "-"
  var month = date.getMonth() + 1<10? "0"+(date.getMonth() + 1):date.getMonth() + 1
  var strDate = date.getDate()<10? "0" + date.getDate() : date.getDate()
  var currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
  return currentdate
}



// WEBPACK FOOTER //
// ./src/utils/index.ts